(() => {

  /** @param {bool} active @returns {string} */
  const getTranslation = (active) => {
    const lang = document.body.parentElement.lang

    if (lang == "en") {
      if (active) {
        return "Close menu"
      } else {
        return "Open menyn"
      }
    }

    if (active) {
      return "Stäng menyn"
    } else {
      return "Öppna menyn"
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector(".main-header")
    let active = false

    if (!header) return

    // TOGGLE CLASSES ------------------------------------------------

    const hamburger = header.querySelector(".mobile-nav .hamburger")
    const hamburgerText = hamburger.querySelector("span.sr-only")

    const backdrop = header.querySelector(".mobile-nav .backdrop")

    hamburger.addEventListener("click", () => {
      active = !active

      backdrop.classList.toggle("active")
      hamburger.classList.toggle("active")
      document.body.classList.toggle("scrollable")

      hamburgerText.innerText = getTranslation(active)
    })

    // MOBILE MENU SWIPER ------------------------------------------------

    const mobileNavRow = header.querySelector(".mobile-nav .nav-row")
    const ulMenu = mobileNavRow.querySelector("ul[role=menubar]")
    const menuAnchors = mobileNavRow.querySelectorAll("a[role=menuitem]")

    menuAnchors.forEach(a => {
      const subMenu = a.nextElementSibling

      a.addEventListener("click", (e) => {
        e.preventDefault()

        ulMenu.classList.toggle("active")
        subMenu.classList.toggle("active")

      })

      const backBtn = subMenu.querySelector(".nav-control")
      backBtn.addEventListener("click", () => {
        ulMenu.classList.remove("active")
        subMenu.classList.remove("active")
      })
    })

    // ------------------------------------------------
  })
})()

// Protected  ------------------------------

$(document).ready(function() {
  $('section.protected1 .btn.yes').on('click', function () {
    Cookies.set('protected1_page1', 'ok');
    $(this).attr("href", $(this).data("url"))
    window.location.href = $(this).data("url");
    return false;
  });

  $('section.protected1 .btn.no').on('click', function () {
    alert($(this).data("message"));
  });

  if($('section.protected1').length > 0) {
    Cookies.set('protected1_cookie_test', 'ok');
    if (Cookies.get('protected1_cookie_test') != 'ok') {
      alert('Den här tjänsten kräver att din webbläsare accepterar kakor (cookies)');
    }
  }

});